import React from "react";

export function GoToPageButton({destination, text, onPageOpen}) {
    return (
        <>
            <br/>
                <button
                    style={{textAlign: "center"}}
                    onClick={() => onPageOpen(destination)}>
                    {text}
                </button>
            <br/>
        </>
    )
}